module.exports = __webpack_public_path__ + "static/media/axiseng.68ae46c1.png";